import { render } from "./settings.dialog.vue?vue&type=template&id=38828a08"
import script from "./settings.dialog.vue?vue&type=script&lang=js"
export * from "./settings.dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__